import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "content"
}
const _hoisted_2 = { key: 1 }

import { ref, computed } from "vue";
import { useStore } from "vuex";
import Tile from "@/components/shared/Tile.vue";
import Error from "@/components/shared/Error.vue";
import GenericUppyUploader from "@/components/shared/GenericUppyUploader.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationFileUpload',
  props: {
  application: {
    type: Object,
    required: true,
  },
  applicant: {
    type: Object,
  },
  height: {
    type: Number,
  },
},
  setup(__props) {

const props = __props;

const store = useStore();
const error = ref<boolean>(false);
const docTypeId = computed<number>(() => store.state.lookupsModule.lookups?.documentTypes?.find((dt: any) => dt?.name?.trim() === 'Unknown')?.id || 1);
const referenceId = computed(() => props.application?.referenceId);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Tile, null, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "header" }, [
        _createElementVNode("p", { class: "title" }, "Have More Docs?")
      ], -1)),
      (!error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(GenericUppyUploader, {
              name: 'application',
              applicationId: __props.application?.id,
              applicant: __props.applicant,
              documentTypeId: docTypeId.value
            }, null, 8, ["applicationId", "applicant", "documentTypeId"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(Error)
          ]))
    ]),
    _: 1
  }))
}
}

})